import { loadWhatfix, setWhatfixVariables } from '@mindtickle/ui-shell-core/Whatfix';
import { getExtendedLogger } from '../Logger';
import logger from '~/config/app.logger';
import { TLocalAuthContext } from '~/components/Auth';
import { getUserLoginStatus } from './helpers';

const log = getExtendedLogger('whatfix', logger);

/* eslint-disable complexity */
export async function initWhatfix(auth?: TLocalAuthContext) {
  // Check if whatfix is disabled for a given track
  if (!process.env.WHATFIX_ENABLED) return;

  // Check if whatfix is disabled for a given company
  if (!auth?.user?.id || auth?.featureToggles?.isWhatfixDisabled) return;

  try {
    const exportedFields = auth?.featureToggles?.whatfixConfig?.exportedProfileFields || [];
    const profileFields =
      auth?.user?.profileFields?.filter((item: any) => exportedFields.includes(item?.field_name)) ||
      [];

    // Setting Whatfix variables before loading the script so that when Whatfix script is loaded, they are already available
    setWhatfixVariables({
      userId: auth.user.id,
      cname: auth.company.id,
      companyType: auth.company.companyType,
      lsType: auth.company.lsType,
      userLoginStatus: getUserLoginStatus(auth),
      locale: auth?.user?.locale,
      email: auth?.user?.email,
      username: auth?.user?.username,
      roles: auth?.user?.roles,
      profileFields,
    });
    await loadWhatfix(auth?.featureToggles?.whatfixConfig);
    log('snippet loaded successfully');
  } catch (error) {
    log('snippet load failed', error);
  }
}
